// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Pzs7","col":"styles_col__qOVAU"};